<template>
<div id="Agents">
    <v-container grid-list-xl fluid>

        <v-layout row wrap>
            <v-flex md12 sm12 class="my-4">
                <h3>INTERBANK / ARCHIVOS</h3>
            </v-flex>

            <v-flex xs12 md6 lg6>
                <v-text-field label="Buscar por Nombre Agente..." v-model="name"></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6>
                <v-text-field label="Buscar por ID Agente..." v-model="identificador"></v-text-field>
            </v-flex>
            <!--<v-flex xs12 md4 lg4>
            <v-text-field label="Buscar por N Serie..." v-model="serie"></v-text-field>
          </v-flex>-->
            <!-- <v-flex xs12 md6 lg6>
            <v-select
              :items="types"
              label="Filtrar Tipo"
              item-text="text"
              item-value="value"
              v-model="type"
            ></v-select>
          </v-flex>-->

            <!-- <v-flex xs12 md4 lg4>
            <v-select
            @change="getProvincias()"
            single-line
            hide-details
            return-object
              menu-props="auto"
              :items="selectDepartaments"
              label="Filtrar Departamento"
              item-text="nombre"
              v-model="departamentFilter"
            ></v-select>
          </v-flex> -->

            <v-flex xs12 md4 lg4>
                <v-autocomplete :search-input.sync="searchDepartament" clearable hide-no-data hide-selected  :items="selectDepartaments" label="Filtrar Departamento" item-text="nombre" item-value="nombre" v-model="departamentFilter"></v-autocomplete>
            </v-flex>

            <v-flex xs12 md4 lg4>
                <v-autocomplete :search-input.sync="searchProvincia" clearable hide-no-data hide-selected  :items="selectProvincias" label="Filtrar Provincia" item-text="nombre" item-value="nombre" v-model="provinciasFilter"></v-autocomplete>
            </v-flex>

            <v-flex xs12 md4 lg4>
                <v-autocomplete :search-input.sync="searchDistrict" clearable hide-no-data hide-selected  :items="selectDistrict" label="Filtrar Distrito" item-text="nombre" item-value="nombre" v-model="districtFilter"></v-autocomplete>
            </v-flex>

            <v-flex xs12 md6 lg6>
                <v-select :items="types" label="Filtrar Documento" item-text="text" item-value="value" v-model="type"></v-select>
            </v-flex>

            <v-flex xs12 md6 lg6>
                <v-select :items="selectDocument" label="Filtrar Estado" item-text="text" item-value="value" v-model="statusDocumentFilter"></v-select>
            </v-flex>
            <v-btn color="success" @click="getList()">Buscar</v-btn>
            <download-excel :data="json_data" :fields="json_fields">
                <v-btn color="blue-grey" class="white--text" :disabled="loaderExcel">
                    <v-icon right dark>assignment_returned</v-icon>Descargar Excel
                </v-btn>
            </download-excel>
        </v-layout>
        <v-divider></v-divider>
        <v-progress-circular indeterminate :size="40" v-if="generalLoader == true" style="position: fixed; bottom: 10%; right: 5%;" color="primary"></v-progress-circular>

        <v-data-table hide-actions :headers="complex.headers" :items="complex.items" item-key="id">
            <template slot="items" slot-scope="props">
                <td>

                    <v-tooltip bottom color="info">
                        <template v-slot:activator="{ on }">
                            <v-btn flat icon color="info" v-on="on" @click="viewDetail( props.item.agents )" :disabled="loader.saveBtn">
                                {{ props.item.agents }}
                            </v-btn>
                        </template>
                        <span>Ver información del agente</span>
                    </v-tooltip>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.direction | truncate(10, '...') }}</td>
                <td>{{ props.item.department }}</td>
                <td>{{ props.item.province }}</td>
                <td>{{ props.item.district }}</td>
                <td>
                    <v-chip v-if="props.item.NL" :disabled="loader.saveBtn" :color="getColor(props.item.NL.status,props.item.NL.exp_date)" dark @click="dialog= true; getData(props.item.NL);"><span>{{ props.item.NL.status }}</span></v-chip>

                    <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
                </td>
                <td>
                    {{ props.item.NL ? props.item.NL.exp_date : ''}}
                </td>
                <td>
                    <v-chip v-if="props.item.DJ" :disabled="loader.saveBtn" :color="getColor(props.item.DJ.status,props.item.DJ.exp_date )" dark @click="dialog= true; getData(props.item.DJ);"><span>{{ props.item.DJ.status }}</span></v-chip>

                    <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
                </td>
                <td>
                    {{ props.item.DJ ? props.item.DJ.exp_date : ''}}
                </td>
                <td>
                    <v-chip v-if="props.item.AU" :disabled="loader.saveBtn" :color="getColor(props.item.AU.status,props.item.AU.exp_date)" dark @click="dialog= true; getData(props.item.AU);"><span>{{ props.item.AU.status }}</span></v-chip>

                    <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
                </td>
                <td>
                    {{ props.item.AU ? props.item.AU.exp_date : ''}}
                </td>
                <td>
                    <v-chip v-if="props.item.LC" :disabled="loader.saveBtn" :color="getColor(props.item.LC.status,props.item.LC.exp_date)" dark @click="dialog= true; getData(props.item.LC);"><span>{{ props.item.LC.status }}</span></v-chip>

                    <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
                </td>
                <td>
                    {{ props.item.LC ? props.item.LC.exp_date : ''}}
                </td>
                <td>
                    <v-tooltip bottom color="info">
                        <template v-slot:activator="{ on }">
                            <v-btn flat icon color="info" v-on="on" @click="viewDetail( props.item.agents )" :disabled="loader.saveBtn">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
        <v-layout row wrap>
            <div class="text-center pt-2">
                <v-pagination v-model="page" :length="pageCount" @input="getList()" @next="getList()" :total-visible="7" @previous="getList()"></v-pagination>
            </div>
        </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Información de Solicitud</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <h2>Datos</h2>
                            <p>
                                <strong>Solicitud:</strong>
                                {{ form.type }}
                            </p>
                            <p>
                                <strong>Fecha de Solicitud:</strong>
                                {{ form.request }}
                            </p>
                            <p>
                                <strong>Fecha de Entrega:</strong>
                                {{ form.request_exp }}
                            </p>
                            <p>
                                <strong>Fecha de Emisión:</strong>
                                {{ form.date }}
                            </p>
                            <p>
                                <strong>Fecha de Vencimiento:</strong>
                                {{ form.exp_date }}
                            </p>
                            <p>
                                <strong>Número del Autorización:</strong>
                                {{ form.num }}
                            </p>
                            <p>
                                <strong>Número del Serie:</strong>
                                {{ form.serie }}
                            </p>
                            <p>
                                <strong>Observaciones:</strong>
                                {{ form.observations }}
                            </p>
                            <p>
                                <strong>Estado:</strong>
                                {{ form.status }}
                            </p>
                            <p>
                                <v-col cols="12" sm="6" md="4" v-if="form.attachment">
                                    <v-flex md6 sm6>
                                        <v-btn color="info" @click="getAttachament(form.attachment)">Ver documento adjunto</v-btn>
                                    </v-flex>
                                </v-col>
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="dialog = false" :disabled="loader.saveBtn">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar :timeout="3000" top right :color="snackbar.color" v-model="snackbar.show">
        <p style="margin: 0">
            <i :class="snackbar.icon"></i>
            &nbsp;
            {{ snackbar.text }}
        </p>
        <v-btn dark flat @click.native="snackbar.show = false" icon>
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>

    <v-icon></v-icon>
</div>
</template>

<script>
import Vue from "vue";
import axios from "@/api/axios/config";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
    data() {
        return {
            search: "",
            isEdit: false,
            id: null,
            page: 1,
            itemsPerPage: 50,
            pageCount: 0,
            name: "",
            value: "",
            type: "",
            departamentFilter: "",
            selectDepartaments: [],
            provinciasFilter: "",
            selectProvincias: [],
            districtFilter: "",
            selectDistrict: [],
            searchDepartament: null,
            searchProvincia: null,
            searchDistrict: null,
            statusDocumentFilter: "",
            statusfilterSelect: "",
            identificador: "",
            serie: "",
            description: "",
            loader: false,
            saveBtn: false,
            rules: {
                required: value => !!value || "Campo requerido."
            },
            appEvents: [],
            complex: {
                headers: [{
                        text: "Agente",
                        value: "agent_id"
                    },
                    {
                        text: "Nombre",
                        value: ""
                    },
                    {
                        text: "Dirección",
                        value: ""
                    },
                    {
                        text: "Departamento",
                        value: ""
                    },
                    {
                        text: "Provincia",
                        value: ""
                    },
                    {
                        text: "Distrito",
                        value: ""
                    },

                    {
                        text: "Norma Legal",
                        value: ""
                    },
                    {
                        text: "Fecha de Vencimiento NL",
                        value: ""
                    },
                    {
                        text: "Declaración Jurada",
                        value: ""
                    },
                    {
                        text: "Fecha de Vencimiento DJ",
                        value: ""
                    },
                    {
                        text: "Autorización de Anuncio",
                        value: ""
                    },
                    {
                        text: "Fecha de Vencimiento AA",
                        value: ""
                    },
                    {
                        text: "Licencia",
                        value: ""
                    },
                    {
                        text: "Fecha de Vencimiento L",
                        value: ""
                    },
                    {
                        text: "",
                        value: ""
                    }
                ],
                items: []
            },
            types: [{
                    value: "DECLARACION JURADA",
                    text: "Declaración jurada"
                },
                {
                    value: "LICENCIA",
                    text: "Licencia"
                },
                {
                    value: "AUTORIZACIÓN DE ANUNCIO",
                    text: "Autorización de Anuncio"
                },
                {
                    value: "NORMA LEGAL",
                    text: "Norma Legal"
                }
            ],
            status: [{
                    value: "PENDIENTE",
                    text: "Pendiente"
                },
                {
                    value: "EN CURSO",
                    text: "En curso"
                },
                {
                    value: "COMPLETADO",
                    text: "Completado"
                },
                {
                    value: "RECHAZADO",
                    text: "Rechazado"
                }
            ],
            statusfilter: [{
                    value: "PENDIENTE",
                    text: "Pendiente"
                },
                {
                    value: "EN CURSO",
                    text: "En curso"
                },
                {
                    value: "VENCIDAD",
                    text: "Solicitud Vencidad"
                }
            ],
            selectDocument: [{
                    value: "Completado",
                    text: "Completado"
                },
                {
                    value: "Sin Información",
                    text: "Sin Información"
                },
            ],
            snackbar: {
                show: false,
                text: "",
                color: "",
                icon: ""
            },
            basic: {
                dialog: false
            },
            dialog: false,
            saveLoader: false,
            removeLoader: false,
            generalLoader: false,
            modalLoader: false,
            disabled: false,
            loaderExcel: false,
            form: {
                agent_id: "",
                num: "",
                serie: "",
                sign_type: "",
                type: "",
                date: "",
                attachment: "",
                exp_date: "",
                status: "",
                observations: "",
                agents: []
            },
            json_fields: {
                Agente: "agents",
                Nombre: "name",
                Dirección: "direction",
                Departamento: "department",
                Provincia: "province",
                Distrito: "district",
                "Norma Legal": "NL.status",
                "Fecha de Vencimiento NL": "NL.exp_date",
                "Declaración Jurada": "DJ.status",
                "Fecha de Vencimiento DJ": "DJ.exp_date",
                "Autorización de Anuncio": "AU.status",
                "Fecha de Vencimiento AU": "AU.exp_date",
                "Licencia": "LC.status",
                "Fecha de Vencimiento Licencia": "LC.exp_date",
            },
            json_data: []
        };
    },
    filters: {
        formatDate: function (date) {
            if (date != null && date != "") {
                return moment(date).format("DD-MM-YYYY");
            }
        },
        truncate: function (text, length, suffix) {
            if (text && text != null && text != undefined) {
                return text.substring(0, length) + suffix;
            }
        }
    },
    mounted() {
        this.getList();
        //this.getListExcel();
    },

    watch: {
        searchDepartament(val) {
            this.selectDepartaments = [];
            axios
                .get(
                    "agents-listDepartamentos?txtSearch=" + val
                )
                .then(response => {
                    this.selectDepartaments = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        searchProvincia(val) {
            this.selectDistrict = [];
            axios
                .get(
                    "agents-listProvincias?txtSearch=" + val
                )
                .then(response => {
                    this.selectProvincias = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        searchDistrict(val) {
          this.selectDistrict = [];
            axios
                .get(
                    "agents-listDistritos?txtSearch=" + val
                )
                .then(response => {
                    this.selectDistrict = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    methods: {
        getList() {
            this.generalLoader = true;

            axios({
                    method: "GET",
                    url: "agents",
                    params: {
                        name: this.name,
                        identificador: this.identificador,
                        type: this.type,
                        status: this.status,
                        serie: this.serie,
                        departamentFilter:  this.departamentFilter,
                        provinciasFilter: this.provinciasFilter,
                        districtFilter: this.districtFilter,
                        statusDocumentFilter: this.statusDocumentFilter,
                        page: this.page,
                        limit: 50
                    },
                }).then(response => {
                    this.complex.items = response.data.data.items;
                    this.pageCount = response.data.data.total;
                    this.generalLoader = false;

                    this.getListExcel();

                })
                .catch(error => {
                    console.log(error);
                });

            /*  axios
                .get(
                  "agents?" +
                    "name=" +
                    this.name +
                    "&identificador=" +
                    this.identificador +
                    "&type=" +
                    this.type +
                    "&status=" +
                    this.statusfilterSelect +
                    "&serie=" +
                    this.serie +
                    "&departamentFilter="+
                    (this.departamentFilter.nombre ? this.departamentFilter.nombre : '')+
                    "&provinciasFilter="+
                    (this.provinciasFilter.nombre ? this.provinciasFilter.nombre : '')+
                    "&districtFilter="+
                    (this.districtFilter.nombre ? this.districtFilter.nombre : '')+
                    "&statusDocumentFilter="+
                    this.statusDocumentFilter+
                    "&page=" +
                    this.page +
                    "&limit=50"
                )
                .then(response => {
                  this.complex.items = response.data.data.items;
                  this.pageCount = response.data.data.total;
                  this.generalLoader = false;

                })
                .catch(error => {
                  console.log(error);
                });*/
        },

        getColor(status, exp_date) {

            let fecha_expiracion = this.$moment(exp_date).format('YYYY-MM');
            let fecha_actual = this.$moment().format('YYYY-MM');

            if (fecha_actual >= fecha_expiracion) {

                return "error";

            } else {

                if (status == "EN CURSO") return "info";
                else if (status == "PENDIENTE") return "warning";
                else if (status == "COMPLETADO") return "success";
                else if (status == "VENCIDAD") return "error";
                else if (status == "VENCIDOD") return "error";

            }

        },
        getColorTexto(exp_date) {

            let fecha_expiracion = this.$moment(exp_date).format('YYYY-MM');
            let fecha_actual = this.$moment().format('YYYY-MM');

            return (fecha_actual >= fecha_expiracion ? 'texto-rojo' : '');

        },
        getListExcel() {
            this.loaderExcel = true;
            axios({
                    method: "GET",
                    url: "agentsall",
                    params: {
                        name: this.name,
                        identificador: this.identificador,
                        type: this.type,
                        status: this.status,
                        serie: this.serie,
                        departamentFilter:  this.departamentFilter,
                        provinciasFilter: this.provinciasFilter,
                        districtFilter: this.districtFilter,
                        statusDocumentFilter: this.statusDocumentFilter,
                        page: this.page,
                        limit: 50
                    },
                }).then(response => {
                    this.json_data = response.data.data.items;
                    this.loaderExcel = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        clearInputs() {
            this.name = "";
            this.value = "";
            this.description = "";
        },
        getData(data) {
            this.form = data;
        },
        getAttachament(url) {
            window.open(url, "_blank");
        },
        viewDetail(id) {
            this.$router.push("/data/agents/agents-detail/" + id);
        },
    }
};
</script>

<style>
.texto-rojo {
    color: red;
    font-weight: bold;
}

.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}

@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@-o-keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes loader {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
